exports.encode = require('./encode');
exports.decode = require('./decode');



//////////////////
// WEBPACK FOOTER
// ./lib/index.js
// module id = 0
// module chunks = 0